import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ProductDetailsViewModel, RackConfigurationViewObject } from '@/types/apiServerContract';

class RackAddAccessoriesModalService extends AbstractModalService {
    public async show(rack: { rackProduct: ProductDetailsViewModel, configurations?: RackConfigurationViewObject[] }): Promise<any> {
        return this.showModal<boolean|any>({
            component: () => import('./RackStartEditModal.vue'),
            componentAttrs: {
                rackProduct: rack.rackProduct,
                configurations: rack.configurations
            },
            options: {
                wide: true,
                placement: 'center'
            }
        });
    }
}

export default new RackAddAccessoriesModalService();
